import {Button, Lead, Loader, Slot, Text, Trail, Typography} from '@logistics-frontend/blocks'
import {Image} from '@logistics-frontend/blocks/image'
import type {PaymentCard} from '@yandex-delivery/api/model/payment'
import React, {memo} from 'react'

import type {PaymentCardErrorCode} from '../../../../../../api/payment'
import {renderWidget} from '../../..'
import {WidgetType} from '../../../types'
import {getIconSrc} from '../PaymentCard/utils'
import {useButtonProps} from './hooks/useButtonProps'
import * as classes from './PaymentCardButton.classes'

export type PaymentCardButtonProps = {
  cardErrorCode?: PaymentCardErrorCode
  errorText?: string
  isPending: boolean
  onPress?: VoidFunction
  paymentCard?: PaymentCard
  title: React.ReactNode
}

export const PaymentCardButton = memo(
  ({cardErrorCode, errorText, isPending, onPress, paymentCard, title}: PaymentCardButtonProps): React.ReactElement => {
    const props = useButtonProps({cardErrorCode, onPress, paymentCard})

    return (
      <Slot className={classes.slotButton} Component={Button} pr="s" size="l" {...props}>
        <Lead>
          {isPending ? (
            <Loader />
          ) : (
            <Image
              alt={paymentCard?.system}
              height={24}
              loading="lazy"
              src={getIconSrc(paymentCard?.system)}
              width={36}
            />
          )}
        </Lead>
        {!isPending && (
          <>
            <Text>
              <Typography group="tight" thickness="regular" variant="body2">
                {title}
              </Typography>
              {errorText && (
                <Typography color="error" data-error="true" group="tight" thickness="regular" variant="caption1">
                  {errorText}
                </Typography>
              )}
            </Text>
            <Trail className={classes.trail}>{renderWidget({type: WidgetType.NAV})}</Trail>
          </>
        )}
      </Slot>
    )
  },
)
